import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ReviewCard from '@/components/base/ReviewCard';
import { aboutStats, aboutFeatures, brandIntro, contactInfo } from '@/mocks/about';
import { aboutReviews } from '@/mocks/reviews';

const baseUrl = 'https://duxiaoguan.cn';

export default function AboutPage() {
  const schemaJson = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${baseUrl}/#website`,
        url: baseUrl,
        name: '吃瓜网在线',
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'AboutPage',
        '@id': `${baseUrl}/about/#aboutpage`,
        url: `${baseUrl}/about`,
        name: '关于我们 - 吃瓜网在线',
        description: '了解吃瓜网在线的品牌故事、平台数据与联系方式。国内领先的娱乐八卦资讯聚合平台。',
        isPartOf: { '@id': `${baseUrl}/#website` },
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'Organization',
        '@id': `${baseUrl}/about/#organization`,
        name: '吃瓜网在线',
        url: baseUrl,
        description: '国内领先的娱乐八卦资讯聚合平台，成立于2020年。',
        email: contactInfo.email,
        address: {
          '@type': 'PostalAddress',
          addressLocality: '北京市朝阳区',
          addressCountry: 'CN',
        },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: baseUrl },
          { '@type': 'ListItem', position: 2, name: '关于我们' },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '吃瓜网的信息来源可靠吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '吃瓜网通过多渠道交叉验证确保信息可靠性，所有爆料均标注来源，并设有AI去重系统过滤虚假内容。我们坚持"有图有真相"原则，拒绝无证据的猜测。',
            },
          },
          {
            '@type': 'Question',
            name: '如何向吃瓜网爆料？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过邮箱tips@chiguawang.com或微信公众号"chiguawang_official"向我们提交爆料。我们严格保护爆料人隐私，支持匿名投稿。',
            },
          },
          {
            '@type': 'Question',
            name: '吃瓜网的内容多久更新一次？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '吃瓜网实行7×24小时实时监控，重大事件发生后30分钟内即可上线相关内容。每日平均更新超过200条各类娱乐资讯。',
            },
          },
          {
            '@type': 'Question',
            name: '吃瓜网有手机APP吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '目前吃瓜网主要通过网页端提供服务，移动端适配已全面完成，在手机浏览器中即可获得流畅的阅读体验。APP正在开发中，敬请期待。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 吃瓜网在线 | 品牌介绍与联系方式"
        description="了解吃瓜网在线的品牌故事、平台数据与联系方式。国内领先的娱乐八卦资讯聚合平台，每日更新最新网红塌房、明星八卦、黑料曝光等内容。"
        keywords="吃瓜网在线,关于吃瓜网,娱乐八卦平台,在线吃瓜,51吃瓜,网红塌房"
        canonicalUrl={`${baseUrl}/about`}
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20about%20page%2C%20warm%20crimson%20and%20amber%20tones%2C%20professional%20atmosphere%2C%20editorial%20style%2C%20clean%20simple%20background%2C%20no%20text&width=1200&height=630&seq=og-about&orientation=landscape"
        schemaJson={schemaJson}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="relative w-full overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              <div className="w-full lg:w-[40%] flex items-center px-4 md:px-6 py-16 lg:py-24">
                <div>
                  <span className="inline-block text-xs bg-primary-100/80 text-primary-600 px-3 py-1 rounded-full font-label mb-3">
                    ABOUT US
                  </span>
                  <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-4">
                    关于
                    <br />
                    吃瓜网
                  </h1>
                  <p className="text-base text-foreground-600 leading-relaxed max-w-md">
                    国内领先的娱乐八卦资讯聚合平台，为您提供最新、最全、最真实的娱乐圈动态。
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-[60%] h-[240px] lg:h-[400px] overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20multiple%20screens%20displaying%20entertainment%20news%2C%20warm%20crimson%20ambient%20lighting%2C%20professional%20atmosphere%2C%20Chinese%20media%20company%20aesthetic%2C%20editorial%20photography%2C%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=about-hero&orientation=landscape"
                  alt="关于吃瓜网"
                  title="吃瓜网办公环境"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 bg-secondary-50/40">
            <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
              <div className="text-center mb-8">
                <span className="inline-block text-xs bg-primary-100/80 text-primary-600 px-3 py-1 rounded-full font-label mb-3">
                  品牌定位
                </span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                  全网最快 · 内容最全 · 爆料最真
                </h2>
                <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
                  我们不只是搬运八卦，我们重新定义吃瓜方式
                </p>
              </div>

              <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
                {aboutFeatures.map((feature) => (
                  <div
                    key={feature.title}
                    className="text-center p-5 bg-background-50 rounded-lg"
                  >
                    <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100/70 flex items-center justify-center">
                      <i className={`ri-check-double-line text-primary-500 text-lg`}></i>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-900 mb-1.5">{feature.title}</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">{feature.description}</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
                {aboutStats.map((stat) => (
                  <div
                    key={stat.label}
                    className="text-center p-6 bg-background-50 rounded-lg"
                  >
                    <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-600">
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500 mt-1">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14">
            <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-5">
                    品牌故事
                  </h2>
                  <div className="text-sm text-foreground-700 leading-relaxed space-y-4">
                    {brandIntro.split('\n\n').map((paragraph, i) => (
                      <p key={i}>{paragraph}</p>
                    ))}
                  </div>
                </div>

                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-5">
                    联系我们
                  </h2>
                  <div className="bg-background-50 rounded-lg p-6 border border-background-200/70 space-y-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-primary-100/70 flex items-center justify-center shrink-0">
                        <i className="ri-mail-line text-primary-500 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">邮箱</p>
                        <p className="text-sm font-medium text-foreground-900">{contactInfo.email}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-primary-100/70 flex items-center justify-center shrink-0">
                        <i className="ri-wechat-line text-primary-500 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">微信公众号</p>
                        <p className="text-sm font-medium text-foreground-900">{contactInfo.wechat}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-primary-100/70 flex items-center justify-center shrink-0">
                        <i className="ri-weibo-line text-primary-500 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">新浪微博</p>
                        <p className="text-sm font-medium text-foreground-900">{contactInfo.weibo}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-primary-100/70 flex items-center justify-center shrink-0">
                        <i className="ri-map-pin-line text-primary-500 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">地址</p>
                        <p className="text-sm font-medium text-foreground-900">{contactInfo.address}</p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-6 bg-primary-50 rounded-lg p-5">
                    <h3 className="text-base font-heading font-bold text-primary-700 mb-2">
                      有猛料要爆？
                    </h3>
                    <p className="text-sm text-foreground-600 mb-3 leading-relaxed">
                      我们严格保护您的隐私安全，所有爆料均可匿名提交。你的信息可能成为下一个全网头条！
                    </p>
                    <a
                      href={`mailto:${contactInfo.email}`}
                      className="inline-flex items-center gap-2 whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label px-5 py-2.5 rounded-full transition-colors cursor-pointer"
                    >
                      发送爆料
                      <i className="ri-send-plane-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 bg-background-100">
            <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
              <div className="text-center mb-8">
                <div className="flex items-center justify-center gap-2 mb-1">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-xs text-foreground-500 font-label uppercase tracking-wider">Reviews</span>
                </div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  瓜友口碑墙
                </h2>
                <p className="text-sm text-foreground-600 mt-2">听听我们的用户怎么说</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {aboutReviews.map((review, index) => (
                  <ReviewCard
                    key={review.id}
                    username={review.username}
                    avatar={review.avatar}
                    role={review.role}
                    rating={review.rating}
                    title={review.title}
                    content={review.content}
                    faded={index === aboutReviews.length - 1}
                  />
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14">
            <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-8">
                常见问题
              </h2>
              <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                  <h3 className="text-sm font-medium text-foreground-900 mb-2">
                    吃瓜网的信息来源可靠吗？
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    吃瓜网通过多渠道交叉验证确保信息可靠性，所有爆料均标注来源，并设有AI去重系统过滤虚假内容。我们坚持"有图有真相"原则。
                  </p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                  <h3 className="text-sm font-medium text-foreground-900 mb-2">
                    如何向吃瓜网爆料？
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    您可以通过邮箱 tips@chiguawang.com 或微信公众号提交爆料。我们严格保护爆料人隐私，支持匿名投稿。
                  </p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                  <h3 className="text-sm font-medium text-foreground-900 mb-2">
                    吃瓜网的内容多久更新一次？
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    实行7×24小时实时监控，重大事件30分钟内上线相关内容。每日平均更新超过200条娱乐资讯。
                  </p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                  <h3 className="text-sm font-medium text-foreground-900 mb-2">
                    吃瓜网有手机APP吗？
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    目前主要通过网页端提供服务，移动端适配已全面完成。APP正在开发中，敬请期待。
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}